/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";

import {WealthyEnv} from "helpers";

import LinkToKyc from "./LinkToKyc";

const LinkToKycContainer = () => {
  const linkKyc = () => {
    window.location.href = `${WealthyEnv.URL}/client/broking/profile`;
  };

  return (
    <LinkToKyc linkKyc={linkKyc} />
  );
};

export default LinkToKycContainer;
